import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IInfoDialogProps {
    dialogName: string;
    hideDialog: () => void;
    label?: string;
    message?: string;
    heading?: string;
}

const InfoDialog = (props: IInfoDialogProps) => {

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('InfoDialog onCreate()');
    };

    return (
        <Dialog title={props?.heading ? props?.heading : 'Information'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    ℹ️
                    {!!props?.label && (
                        <>
                            <label>{props.label}</label>
                            <br />
                        </>
                    )}
                    <label style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>{props?.message ? props?.message : ''}</label>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default InfoDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/dialogs/InfoDialog.tsx